import api from './axios';

/**
 * Reports (spec §14). A Branch Admin's figures are scoped server-side, so the
 * same call returns their branch's numbers rather than a filtered global set.
 */
export const getReportSummary     = (params = {})   => api.get('/v1/reports/summary', { params });
export const getAcquisition       = (params = {})   => api.get('/v1/reports/acquisition', { params });
export const getBranchPerformance = ()              => api.get('/v1/reports/branch-performance');
export const getRevenueTrend      = (params = {})   => api.get('/v1/reports/revenue', { params });

/**
 * Queues a CSV of one report. The key travels in the BODY, not the path:
 * `/report-exports/{reportKey}` and `/report-exports/{id}` are the same
 * OpenAPI template and would be ambiguous.
 */
export const createReportExport = (payload) => api.post('/v1/report-exports', payload, {
  headers: { 'Idempotency-Key': (crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`) },
});

export const getReportExport = (id) => api.get(`/v1/report-exports/${id}`);

